import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

import Home from '@/views/Home.vue'; 
import Details from '@/views/Details.vue';
import ProductDetail from '@/views/ProductDetail.vue';
import Exhibition from '@/views/Exhibition.vue';
import ExhibitionDetail from '@/views/ExhibitionDetail.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  }, {
    path: '/details', 
    name: 'Details',
    component: Details
  }, {
    path: '/productDetail', 
    name: 'ProductDetail',
    component: ProductDetail
  },{
    path: '/exhibition', 
    name: 'Exhibition',
    component: Exhibition
  }, {
    path: '/exhibitionDetail', 
    name: 'ExhibitionDetail',
    component: ExhibitionDetail
  }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});

export default router;
